// src/pages/TermsOfUsePage.js
import React from 'react';
import Navbar from '../components/common/Navbar/Navbar';
import Footer from '../components/common/Footer/Footer';
import './PolicyPages.css';

const TermsOfUsePage = () => {
    return (
        <div className="policy-page">
            <Navbar />

            <div className="policy-header">
                <div className="container">
                    <h1>Terms of Use</h1>
                    <p className="last-updated">Last Updated: March 17, 2025</p>
                </div>
            </div>

            <div className="policy-content">
                <div className="container">
                    <div className="policy-container">
                        <div className="policy-introduction">
                            <p>
                                Welcome to Abhyaas Educational Trust. By accessing our website, you agree to comply with and be bound by the following terms and conditions of use. Please read these terms carefully before using our website or services.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Acceptance of Terms</h2>
                            <p>
                                By accessing or using our website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use. If you do not agree with these terms, please do not use our website.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Use of Website</h2>
                            <p>
                                This website is intended for personal, non-commercial use. You agree to use this website only for lawful purposes and in a manner that does not infringe upon the rights of others or restrict or inhibit anyone else's use or enjoyment of the website.
                            </p>
                            <p>
                                You agree not to:
                            </p>
                            <ul>
                                <li>Use the website for any illegal or unauthorized purpose</li>
                                <li>Attempt to gain unauthorized access to any portion of the website</li>
                                <li>Interfere with or disrupt the operation of the website</li>
                                <li>Collect or harvest any information from the website without our permission</li>
                                <li>Upload or transmit any viruses, worms, or other harmful code</li>
                            </ul>
                        </div>

                        <div className="policy-section">
                            <h2>Intellectual Property</h2>
                            <p>
                                All content on this website, including but not limited to text, graphics, logos, images, audio clips, video clips, and software, is the property of Abhyaas Educational Trust or its content suppliers and is protected by copyright, trademark, and other intellectual property laws.
                            </p>
                            <p>
                                You may view, download, and print content from this website for your personal, non-commercial use, provided you:
                            </p>
                            <ul>
                                <li>Do not remove any copyright, trademark, or other proprietary notices</li>
                                <li>Do not modify or alter the content in any way</li>
                                <li>Do not use the content in a manner that suggests an association with our products, services, or brand</li>
                                <li>Do not reproduce, duplicate, copy, sell, or exploit the content for any commercial purpose</li>
                            </ul>
                        </div>

                        <div className="policy-section">
                            <h2>Links to Third-Party Websites</h2>
                            <p>
                                Our website may contain links to third-party websites or services that are not owned or controlled by Abhyaas Educational Trust. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.
                            </p>
                            <p>
                                You acknowledge and agree that Abhyaas Educational Trust shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Disclaimer of Warranties</h2>
                            <p>
                                This website is provided on an "as is" and "as available" basis. Abhyaas Educational Trust makes no representations or warranties of any kind, express or implied, as to the operation of the website or the information, content, materials, or products included on this website.
                            </p>
                            <p>
                                To the full extent permissible by applicable law, Abhyaas Educational Trust disclaims all warranties, express or implied, including but not limited to, implied warranties of merchantability and fitness for a particular purpose.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Limitation of Liability</h2>
                            <p>
                                Abhyaas Educational Trust will not be liable for any damages of any kind arising from the use of this website, including but not limited to direct, indirect, incidental, punitive, and consequential damages.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Indemnification</h2>
                            <p>
                                You agree to indemnify, defend, and hold harmless Abhyaas Educational Trust, its officers, directors, employees, agents, and affiliates from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that such parties may incur as a result of or arising from your violation of these Terms of Use.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Changes to Terms</h2>
                            <p>
                                We reserve the right to modify these Terms of Use at any time. We will notify users of material changes by posting the new Terms of Use on this page with an updated "Last Updated" date. Your continued use of the website after any such changes constitutes your acceptance of the new Terms of Use.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Governing Law</h2>
                            <p>
                                These Terms of Use shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.
                            </p>
                        </div>

                        <div className="policy-section">
                            <h2>Contact Us</h2>
                            <p>
                                If you have any questions about these Terms of Use, please contact us at:
                            </p>
                            <div className="contact-info">
                                <p>Email: <a href="mailto:abhyaas@littleelly.com">abhyaas@littleelly.com</a></p>
                                <p>Phone: +91 90198 29264</p>
                                <p>Address: Little Elly Campus, Kudlu Main Road, Bengaluru, Karnataka 560068</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TermsOfUsePage;